import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>0:35</span> About Guest</li>
                            <li><span>10:26</span> Neuroscience of Communication</li>
                            <li><span>13:15</span> Content Vs. Copy</li>
                            <li><span>17:56</span> Emotional Intelligence & AI-generated content</li>
                            <li><span>20:09</span> AI & Human Collaboration</li>
                            <li><span>23:03</span> The need for AI-generated content</li>
                            <li><span>27:56</span> Some numbers about Lately</li>
                            <li><span>28:26</span> How Lately works?</li>
                            <li><span>31:43</span> Lately for Startups & Enterprises</li>
                            <li><span>35:25</span> Myths about AI-generated content</li>
                            <li><span>36:45</span> The biggest challenge for Lately</li>
                            <li><span>42:31</span> Advice for entrepreneurs</li>
                            <li><span>45:18</span> Kate’s Mentors</li>
                            <li><span>48:50</span> Things Kate would like to change about the industry</li>
                            <li><span>51:05</span> Constant iteration</li>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;